// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"960186cb","455":"e1892137","977":"b25ff4c3"}[chunkId] + ".chunk.js";
};